export function isMissingMapIdDisplayValue(value: unknown): boolean {
  return value == null || value === '';
}

export function mappedArtifactDisplayName(
  artifact: Record<string, unknown> | null | undefined,
  displayField?: string): string {
  if (!artifact) {
    return '';
  }
  if (displayField) {
    const named = artifact[displayField];
    if (typeof named === 'string' && named) {
      return named;
    }
  }
  const artifactName = artifact['artifact_name'];
  return typeof artifactName === 'string' ? artifactName : '';
}

export function copyMapIdDisplayCompanions(
  source: Record<string, unknown> | null | undefined,
  target: Record<string, unknown> | null | undefined,
  fieldName: string): void {
  if (!source || !target || !fieldName) {
    return;
  }
  copyCompanion(source, target, `${fieldName}_value`);
  copyCompanion(source, target, `$$${fieldName}_value`);
}

function copyCompanion(
  source: Record<string, unknown>,
  target: Record<string, unknown>,
  companionName: string): void {
  if (isMissingMapIdDisplayValue(target[companionName]) &&
    !isMissingMapIdDisplayValue(source[companionName])) {
    target[companionName] = source[companionName];
  }
}
